/**
 * A component that renders a rating out of 5 stars.
 *
 * @param {{ rating: number }} props
 * The rating to render. It should be a number between 0 and 5.
 *
 * @returns {React.ReactElement}
 * A JSX element representing the rating.
 */
const StarRating = ({ rating: userRating }) => {
  const totalStars = 5;
  const filledStars = Math.min(Math.max(Math.floor(userRating), 0), totalStars);

  return (
    <div className="inline-flex items-center gap-1.5">
      {[...Array(filledStars)].map((_, index) => (
        <svg
          key={`filled-${index}`}
          className="h-5 w-5 text-amber-400 drop-shadow-[0_1px_2px_rgba(245,158,11,0.35)]"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 22 20"
        >
          <defs>
            <linearGradient
              id={`star-fill-${index}`}
              x1="0"
              y1="0"
              x2="0"
              y2="1"
            >
              <stop offset="0%" stopColor="#fbbf24" />
              <stop offset="100%" stopColor="#f59e0b" />
            </linearGradient>
          </defs>
          <path
            fill={`url(#star-fill-${index})`}
            d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"
          />
        </svg>
      ))}

      {[...Array(totalStars - filledStars)].map((_, index) => (
        <svg
          key={`empty-${index}`}
          className="h-5 w-5 text-gray-100 dark:text-gray-700"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 22 20"
        >
          <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
        </svg>
      ))}
    </div>
  );
};

export default StarRating;
